import { Cache } from 'aws-amplify';
import DataAccess from "../data/DataAccess";
import {ArrayUtil} from "oca-lib-web";

export default class DataManager {

    private dataAccess:DataAccess;
    private cacheEnabled = false;

    constructor(dataAccess:DataAccess) {
        this.dataAccess = dataAccess;
    }

    public config() {
        /*const config = {
            itemMaxSize: 3000, // 3000 bytes
            defaultPriority: 4
        };*/

        const config = {
            storage: window.sessionStorage
        };

        //this.cacheInstance = Cache.createInstance(config);
        Cache.configure(config);
    }

    public async get(dataMethod:string, param?:any):Promise<any> {
        var self = this;
        var cacheSuffix = param?.id ? ("_" + param?.id) : param ? ("_" + param) : "";
        return new Promise<any>(async function(resolve) {
            let fullCacheKey = dataMethod + cacheSuffix;
            let items = Cache.getItem(fullCacheKey);
            if (items && self.cacheEnabled) {
                console.log("Getting " + fullCacheKey + " from cache");
                resolve(items);
            } else {
                let items = await self.dataAccess[dataMethod](param);
                console.log("Getting " + fullCacheKey + " from network");
                Cache.setItem(fullCacheKey, items);
                resolve(items);
            }
        });
    }

    public async save(dataMethod:string, param:any):Promise<any> {
        var self = this;
        return new Promise<any>(async function(resolve) {
            let result = await self.dataAccess[dataMethod](param);

            if (self.cacheEnabled) {
                let objectName = self.getObjectName(dataMethod);
                let keys = await self.getAllKeys();
                for (let key of keys) {
                    // Need to determine if new. If it is new than we go through each object and look for array and of object type than add
                    let items = Cache.getItem(key);
                    if (Array.isArray(items)) {
                        let found = false;
                        if (key.toLowerCase().indexOf(objectName) > -1 && self.isNewObject(param)) {
                            found = true;
                        } else {
                            for (let item of items) {
                                if (item.id == param.id) {
                                    found = true;
                                    ArrayUtil.deleteItem(item, items);
                                }
                            }
                        }
                        if (found) {
                            items.push(result);
                            Cache.setItem(key, items);
                        }
                    } else {
                        if (items.id == param.id) {
                            Cache.setItem(key, param);
                        }
                    }
                }
            }
            resolve(param);
        });
    }

    public async perform(dataMethod:string, param:any):Promise<any> {
        var self = this;
        return new Promise<any>(async function(resolve) {
            let result = await self.dataAccess[dataMethod](param);
            resolve(result);
        });
    }

    public isNewObject(param:any) {
        return !param["id"];
    }

    public getObjectName(dataMethod:string):string {
        return dataMethod.replace("create", "").toLowerCase();
    }

    public async delete(dataMethod:string, param:any):Promise<any> {
        var self = this;
        return new Promise<any>(async function(resolve) {
            await self.dataAccess[dataMethod](param);

            if (self.cacheEnabled) {
                let keys = await self.getAllKeys();
                for (let key of keys) {
                    let items = Cache.getItem(key);
                    if (Array.isArray(items)) {
                        let found = false;
                        for (let item of items) {
                            if (item.id == param.id) {
                                ArrayUtil.deleteItem(item, items);
                                found = true;
                            }
                        }
                        if (found) {
                            Cache.setItem(key, items);
                        }
                    } else {
                        if (items.id == param.id) {
                            Cache.removeItem(key);
                        }
                    }
                }
            }
            resolve(param);
        });
    }

    // Cache methods

    public clear() {
        Cache.clear();
    }

    public currentCacheSize() {
        const size = Cache.getCacheCurSize();
        return size;
    }

    public getAllKeys() {
        return Cache.getAllKeys();
    }
}